module.exports = __webpack_public_path__ + "static/media/ausbildung.78060830.jpg";